import React from 'react';

import DataSelect from '../common/DataSelect';
import { useGetPromptTemplatesQuery } from '../../redux/services/promptTemplateApi';

const SelectPromptTemplateInput = ({
  label = 'Prompt Template',
  ...props
}) => {
  return (
    <DataSelect
      defaultValue={1}
      useGetQuery={useGetPromptTemplatesQuery}
      label={props?.hideLabel ? null : label}
      mapRowToOption={template => ({
        value: template.id,
        label: template.display_name + ' (latest)'
      })}
      {...props}
    />
  );
};

export default SelectPromptTemplateInput;

